import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from 'react-bootstrap/Button';
import { TemplateType } from '../../consts/forms-types';
import { startCase } from 'lodash';
import { TitleFormattedMessage } from '../../components/titleFormattedMessage';
import PropdocsModal from '../../components/modal/PropdocsModal';

type DraftModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onUpdateDraft: () => void;
  templateType: TemplateType | undefined;
};

const DraftModal = ({ isOpen, onClose, onUpdateDraft, templateType }: DraftModalProps) => {
  const templateTypeString = (uppercase: boolean = false) => {
    const type = templateType === TemplateType.CLAUSE ? 'clause' : 'template';
    return uppercase ? startCase(type) : type;
  };

  const modalContent =
    templateType === TemplateType.CLAUSE
      ? 'Deactivating a clause means you can no longer insert this clause in to a document.'
      : 'Deactivating a template means you can no longer create documents using this template.';

  return (
    <PropdocsModal
      show={isOpen}
      setShow={onClose}
      size="md"
      title={
        <FormattedMessage id="title.deactivate-template" defaultMessage={`Deactivate ${templateTypeString(true)}`} />
      }
    >
      <>
        <div>
          <p>
            <FormattedMessage id="phrase.draft-template" defaultMessage={modalContent} />
          </p>
          <p>
            <FormattedMessage
              id="phrase.deactivate-template-reversal"
              defaultMessage="This can be reversed at a later date by activating the {type} again."
              values={{ type: templateTypeString() }}
            />
          </p>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', padding: '1rem 0 1rem 0' }}>
          <Button variant="link" className="text-secondary" onClick={onClose}>
            <TitleFormattedMessage id="cta.cancel" defaultMessage="Cancel" />
          </Button>
          <Button
            variant="secondary"
            onClick={() => {
              onUpdateDraft();
            }}
          >
            <TitleFormattedMessage id="cta.deactivate" defaultMessage={`Deactivate`} />
          </Button>
        </div>
      </>
    </PropdocsModal>
  );
};

export default DraftModal;
